import React, { useEffect, useState } from "react";
import "./index.css";
import Cookies from "universal-cookie";
import { MdOutlineWatchLater } from "react-icons/md";
import { MdDoNotDisturb } from "react-icons/md";

const WoInfoOrderS = ({
  tranId,
  surveys,
  singleWorkOrder,
  onDeviceClick,
  highlightedSerial,
  displayedDevices,
  contacts,
  singleWorkOrderCategory,
  highlightedSerial1,
  onDeviceClick1,
  handleSort,
  sortedAsc,
}) => {
  // const [surveys, setSurveys] = useState([]);

  const cookies = new Cookies();
  const token = cookies.get("token");
  const Surveys = surveys || [];

  const formatDate = (isoString) => {
    if (!isoString) return "—";
    const dt = new Date(isoString);
    return dt.toLocaleString("en-Us", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  // useEffect(() => {
  //   const fetchSurveys = async () => {
  //     if (tranId) {
  //       try {
  //         const response = await fetch(
  //           `${process.env.REACT_APP_API}/task/survey-by-order-id-admin/${tranId}`,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         const data = await response.json();
  //         console.log("surveys----->", data.data);
  //         if (
  //           data.data.taskCompleted.length > 0 ||
  //           data.data.taskInCompleted.length > 0
  //         ) {
  //           const combinedTasks = [
  //             ...data.data.taskCompleted,
  //             ...data.data.taskInCompleted,
  //           ];
  //           setSurveys(combinedTasks);
  //         } else {
  //           setSurveys([]);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching surveys:", error);
  //         setSurveys([]);
  //       }
  //     }
  //   };
  //   fetchSurveys();
  // }, [tranId]);
  //
  function getDisplayName(deviceName) {
    return deviceName.replace("INVENTORY - DIGITAL POSTER -", "");
  }

  function DeviceSSID({ devices = [], serialNumber }) {
    if (!Array.isArray(devices) || devices.length === 0 || !serialNumber) {
      return <>Loading...</>; // or just return null
    }

    const device = devices.find(
      d => d.custrecord_ce_mfg_serial_number?.toString() === serialNumber?.toString()
    );

    return <>{device?.wifiSSID || "N/A"}</>;
  }
  // Example
  // const originalName = "Digital – Inventory - Laptop";
  // const displayName = getDisplayName(originalName); // "Laptop"

  // console.log("singleWorkOrderCategory", singleWorkOrderCategory);

  return (
    <>
      <div className="summerycls">
        {Surveys.map((d) => (
          <div key={d.key}>
            <div
              style={{ padding: "12px 12px 12px 12px", cursor: "pointer" }}
              onClick={() => onDeviceClick(d.serialNumber)}
              id={`survey-${d.serialNumber}`}
              className={`${highlightedSerial1 === d.serialNumber ? "highlighted" : ""}`}
            >
              <div className="sumhead">{d.title}</div>
              <div className="sumcontent">{d.device}</div>
              <div className="sumcontent">Serial Number: {d.serialNumber}</div>

              <div className="sumcontent">
                SSID: <DeviceSSID devices={singleWorkOrder.device} serialNumber={d.serialNumber} />
              </div>

              <div className="sumcontent">Room #: {d.room || "N/A"}</div>
            </div>
            <hr style={{ margin: "0rem" }} />
          </div>
        ))}
      </div>
      <div className="summerycls">
        {singleWorkOrderCategory?.length === 0 ? (
          <div className="p-2"> No data found.</div>
        ) : (
          singleWorkOrderCategory?.map((d) => (
            <div key={d.serial_number}>
              <div
                onClick={() =>
                  onDeviceClick1(d.custrecord_ce_mfg_serial_number)
                }
                id={`device-${d.custrecord_ce_mfg_serial_number}`}
                className={`d-flex justify-content-between align-items-center ${highlightedSerial === d.custrecord_ce_mfg_serial_number
                  ? "highlighted"
                  : ""
                  }`}
                // className="d-flex justify-content-between align-items-center"
                // id={`device-${d.custrecord_ce_mfg_serial_number}`}
                // className={`d-flex justify-content-between align-items-center ${
                //   highlightedSerial === d.custrecord_ce_mfg_serial_number
                //     ? "highlighted"
                //     : ""
                // }`}
                style={{ padding: "12px 12px 12px 12px", cursor: "pointer" }}
              >
                <div>
                  <div className="sumhead">{getDisplayName(d.name)}</div>
                  <div className="sumcontent">
                    Serial Number: {d.custrecord_ce_mfg_serial_number}
                  </div>
                  <div className="sumcontent">
                    SSID: {d?.wifiSSID || "N/A"}
                  </div>
                  <div className="sumcontent">
                    Room #: {d.custrecord_bg_room || "N/A"}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-3 ">
                  <div
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {d.heartbeatUpdated && <MdOutlineWatchLater />}
                    {d.heartbeatUpdated ? (
                      formatDate(d.heartbeatUpdated)
                    ) : (
                      <>
                        <div class="tooltip-container">
                          <MdDoNotDisturb class="tooltip-target" />
                          <div class="tooltip-content">
                            Device Not Found
                            <div class="tooltip-arrow"></div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {/* sky kit lat playing control icon set */}
                  <div
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {d?.custrecord_dpvc_network_assigned && d?.lastPlayedContentName && (d.custrecord_dpvc_network_assigned?.toLowerCase() === d.lastPlayedContentName?.toLowerCase()) ? (
                      <div class="tooltip-container">

                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.23177 0.315019C2.57656 -0.0911593 1.75312 -0.10455 1.08464 0.274847C0.416146 0.654245 0 1.3684 0 2.14505V17.8566C0 18.6332 0.416146 19.3474 1.08464 19.7268C1.75312 20.1062 2.57656 20.0883 3.23177 19.6866L15.9818 11.8308C16.6148 11.4425 17 10.7507 17 10.0008C17 9.25094 16.6148 8.56356 15.9818 8.17077L3.23177 0.315019Z" fill="#8AC640" />
                          <path d="M10.7533 8.46418C11.0822 8.12944 11.0822 7.58581 10.7533 7.25106C10.4244 6.91631 9.89031 6.91631 9.56142 7.25106L5.94886 10.9306L4.43858 9.39344C4.10969 9.05869 3.57556 9.05869 3.24667 9.39344C2.91778 9.72819 2.91778 10.2718 3.24667 10.6066L5.35159 12.7489C5.68048 13.0837 6.2146 13.0837 6.5435 12.7489L10.7533 8.46418Z" fill="white" />
                        </svg>
                        <div class="tooltip-content">
                          NS: ({d.custrecord_dpvc_network_assigned}) <br />
                          SK: ({d.lastPlayedContentName})
                          <div class="tooltip-arrow"></div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div class="tooltip-container">

                          <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.23177 0.315019C2.57656 -0.0911593 1.75312 -0.10455 1.08464 0.274847C0.416146 0.654245 0 1.3684 0 2.14505V17.8566C0 18.6332 0.416146 19.3474 1.08464 19.7268C1.75312 20.1062 2.57656 20.0883 3.23177 19.6866L15.9818 11.8308C16.6148 11.4425 17 10.7507 17 10.0008C17 9.25094 16.6148 8.56356 15.9818 8.17077L3.23177 0.315019Z" fill="#FF3535" />
                            <path d="M9.82243 8.02468C10.0567 7.79041 10.0567 7.40996 9.82243 7.1757C9.58816 6.94143 9.20771 6.94143 8.97345 7.1757L7 9.15102L5.02468 7.17757C4.79041 6.94331 4.40996 6.94331 4.1757 7.17757C3.94143 7.41184 3.94143 7.79228 4.1757 8.02655L6.15102 10L4.17757 11.9753C3.94331 12.2096 3.94331 12.59 4.17757 12.8243C4.41184 13.0586 4.79228 13.0586 5.02655 12.8243L7 10.849L8.97532 12.8224C9.20959 13.0567 9.59004 13.0567 9.8243 12.8224C10.0586 12.5882 10.0586 12.2077 9.8243 11.9734L7.84898 10L9.82243 8.02468Z" fill="white" />
                          </svg>
                          <div class="tooltip-content">
                            NS: ({d?.custrecord_dpvc_network_assigned && d.custrecord_dpvc_network_assigned !== "" ? d.custrecord_dpvc_network_assigned : 'N/A'}) <br />
                            SK: ({d?.lastPlayedContentName ?? 'N/A'})
                            <div class="tooltip-arrow"></div>
                          </div>

                        </div>
                      </>
                    )}
                  </div>


                  <div
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {d?.controlVersionName && /^\d+(\.\d+)*$/.test(d.controlVersionName) ? (
                      <div class="tooltip-container">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.24244 0.286706C8.00811 0.0406519 7.6566 -0.0530829 7.32853 0.0328406C7.00046 0.118764 6.74659 0.38044 6.66067 0.708512L6.04358 3.14952L3.6221 2.46604C3.29403 2.3723 2.94252 2.46604 2.70428 2.70428C2.46604 2.94252 2.3723 3.29403 2.46604 3.6221L3.14952 6.04358L0.708512 6.66458C0.38044 6.74659 0.12267 7.00436 0.0328406 7.33244C-0.0569885 7.66051 0.0406519 8.00811 0.286706 8.24244L2.0911 9.99997L0.286706 11.7575C0.0406519 11.9918 -0.0530829 12.3433 0.0328406 12.6714C0.118764 12.9995 0.38044 13.2533 0.708512 13.3393L3.14952 13.9564L2.46604 16.3778C2.3723 16.7059 2.46604 17.0574 2.70428 17.2957C2.94252 17.5339 3.29403 17.6276 3.6221 17.5339L6.04358 16.8504L6.66067 19.2914C6.74269 19.6195 7.00046 19.8773 7.32853 19.9671C7.6566 20.0569 8.0042 19.9593 8.24244 19.7171L9.99997 17.9127L11.7575 19.7171C11.9957 19.9593 12.3433 20.0569 12.6714 19.9671C12.9995 19.8773 13.2533 19.6195 13.3393 19.2914L13.9564 16.8504L16.3778 17.5339C16.7059 17.6276 17.0574 17.5339 17.2957 17.2957C17.5339 17.0574 17.6276 16.7059 17.5339 16.3778L16.8504 13.9564L19.2914 13.3393C19.6195 13.2573 19.8773 12.9995 19.9671 12.6714C20.0569 12.3433 
                              19.9593 11.9918 19.7171 11.7575L17.9127 9.99997L19.7171 8.24244C19.9593 8.0042 20.0569 7.6566 19.9671 
                              7.32853C19.8773 7.00046 19.6195 6.74659 19.2914 6.66067L16.8504 6.04358L17.5339 3.6221C17.6276 3.29403 
                              17.5339 2.94252 17.2957 2.70428C17.0574 2.46604 16.7059 2.3723 16.3778 2.46604L13.9564 3.14952L13.3354 
                              0.708512C13.2533 0.38044 12.9956 0.12267 12.6675 0.0328406C12.3394 -0.0569885 11.9918 0.0406519 11.7575 
                              0.286706L9.99997 2.0911L8.24244 0.286706Z" fill="#8AC640" />
                          <path d="M7 14V12.1935H10.5752C10.7318 12.1938 10.8825 12.1342 10.9963 12.0272C11.1102 11.9201 11.1784 11.7737 11.187 11.6181C11.213 11.1406 10.9952 10.9032 10.5415 10.9032H9.92963C9.29162 10.9069 8.67752 10.6618 8.21868 10.2205C7.75985 9.77925 7.49272 9.17675 7.47444 8.54194C7.44679 6.84731 8.26778 6 9.93741 6H14V7.80645H9.69111C9.53362 7.80489 9.38159 7.86383 9.26665 7.97103C9.15172 8.07822 9.08274 8.2254 9.07407 8.38194C9.05593 8.85935 9.27111 9.09677 9.72481 9.09677H10.3704C11.0079 9.09313 11.6217 9.33781 12.0804 9.77854C12.5392 10.2193 12.8066 10.8211 12.8256 11.4555C12.8549 13.1518 12.0365 14 10.3704 14H7Z" fill="white" />
                        </svg>
                        <div class="tooltip-content">
                          SkyKit control Version ({d.controlVersionName})
                          <div class="tooltip-arrow"></div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div class="tooltip-container">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.24244 0.286706C8.00811 0.0406519 7.6566 -0.0530829 7.32853 0.0328406C7.00046 0.118764 6.74659 0.38044 6.66067 0.708512L6.04358 3.14952L3.6221 2.46604C3.29403 2.3723 2.94252 2.46604 2.70428 2.70428C2.46604 2.94252 2.3723 3.29403 2.46604 3.6221L3.14952 6.04358L0.708512 6.66458C0.38044 6.74659 0.12267 7.00436 0.0328406 7.33244C-0.0569885 7.66051 0.0406519 8.00811 0.286706 8.24244L2.0911 9.99997L0.286706 11.7575C0.0406519 11.9918 -0.0530829 12.3433 0.0328406 12.6714C0.118764 12.9995 0.38044 13.2533 0.708512 13.3393L3.14952 13.9564L2.46604 16.3778C2.3723 16.7059 2.46604 17.0574 2.70428 17.2957C2.94252 17.5339 3.29403 17.6276 3.6221 17.5339L6.04358 16.8504L6.66067 19.2914C6.74269 19.6195 7.00046 19.8773 7.32853 19.9671C7.6566 20.0569 8.0042 19.9593 8.24244 19.7171L9.99997 17.9127L11.7575 19.7171C11.9957 19.9593 12.3433 20.0569 12.6714 19.9671C12.9995 19.8773 13.2533 19.6195 13.3393 19.2914L13.9564 16.8504L16.3778 17.5339C16.7059 17.6276 17.0574 17.5339 17.2957 17.2957C17.5339 17.0574 17.6276 16.7059 17.5339 16.3778L16.8504 13.9564L19.2914 13.3393C19.6195 13.2573 19.8773 12.9995 19.9671 12.6714C20.0569 12.3433 19.9593 11.9918 19.7171 11.7575L17.9127 9.99997L19.7171 8.24244C19.9593 8.0042 20.0569  7.6566 19.9671 7.32853C19.8773 7.00046 19.6195 6.74659 19.2914 6.66067L16.8504 6.04358L17.5339 3.6221C17.6276 3.29403 17.5339 2.94252 17.2957 2.70428C17.0574 2.46604 16.7059 2.3723 16.3778 2.46604L13.9564 3.14952L13.3354 0.708512C13.2533 0.38044 12.9956 0.12267 12.6675 0.0328406C12.3394 -0.0569885 11.9918 0.0406519 11.7575 0.286706L9.99997 2.0911L8.24244 0.286706Z" fill="#FF3535" />

                            <path d="M7 14V12.1935H10.5752C10.7318 12.1938 10.8825 12.1342 10.9963 12.0272C11.1102 11.9201 11.1784 11.7737 11.187 11.6181C11.213 11.1406 10.9952 10.9032 10.5415 10.9032H9.92963C9.29162 10.9069 8.67752 10.6618 8.21868 10.2205C7.75985 9.77925 7.49272 9.17675 7.47444 8.54194C7.44679 6.84731 8.26778 6 9.93741 6H14V7.80645H9.69111C9.53362 7.80489 9.38159 7.86383 9.26665 7.97103C9.15172 8.07822 9.08274 8.2254 9.07407 8.38194C9.05593 8.85935 9.27111 9.09677 9.72481 9.09677H10.3704C11.0079 9.09313 11.6217 9.33781 12.0804 9.77854C12.5392 10.2193 12.8066 10.8211 12.8256 11.4555C12.8549 13.1518 12.0365 14 10.3704 14H7Z" fill="white" />
                            <path
                              d="M21.5 19L5.5 3"
                              stroke="#FF3535"
                              stroke-width="2"
                              stroke-linecap="round"
                            />

                          </svg>
                          <div class="tooltip-content">
                            Device is not Skykit Control
                            <div class="tooltip-arrow"></div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div style={{ fontSize: "20px" }}>
                    <div class="tooltip-container">
                      {d.online ? (
                        <>
                          {/* <FaWifi  color="green" class="tooltip-target"  /> */}
                          <svg
                            width="22"
                            height="20"
                            class="tooltip-target"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20.7778 0C21.4538 0 22 0.558594 22 1.25V18.75C22 19.4414 21.4538 20 20.7778 20C20.1017 20 19.5556 19.4414 19.5556 18.75V1.25C19.5556 0.558594 20.1017 0 20.7778 0ZM15.8889 3.75C16.5649 3.75 17.1111 4.30859 17.1111 5V18.75C17.1111 19.4414 16.5649 20 15.8889 20C15.2128 20 14.6667 19.4414 14.6667 18.75V5C14.6667 4.30859 15.2128 3.75 15.8889 3.75ZM12.2222 8.75V18.75C12.2222 19.4414 11.676 20 11 20C10.324 20 9.77778 19.4414 9.77778 18.75V8.75C9.77778 8.05859 10.324 7.5 11 7.5C11.676 7.5 12.2222 8.05859 12.2222 8.75ZM6.11111 11.25C6.78715 11.25 7.33333 11.8086 7.33333 12.5V18.75C7.33333 19.4414 6.78715 20 6.11111 20C5.43507 20 4.88889 19.4414 4.88889 18.75V12.5C4.88889 11.8086 5.43507 11.25 6.11111 11.25ZM2.44444 16.25V18.75C2.44444 19.4414 1.89826 20 1.22222 20C0.546181 20 0 19.4414 0 18.75V16.25C0 15.5586 0.546181 15 1.22222 15C1.89826 15 2.44444 15.5586 2.44444 16.25Z"
                              fill="#8AC640"
                            />
                          </svg>

                          <div class="tooltip-content">
                            Online
                            <div class="tooltip-arrow"></div>
                          </div>
                        </>
                      ) : (
                        <>
                          {/* <RiWifiOffFill   color="red"  class="tooltip-target" /> */}
                          <svg
                            width="23"
                            height="21"
                            class="tooltip-target"
                            viewBox="0 0 23 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20.7778 0C21.4538 0 22 0.558594 22 1.25V18.75C22 19.4414 21.4538 20 20.7778 20C20.1017 20 19.5556 19.4414 19.5556 18.75V1.25C19.5556 0.558594 20.1017 0 20.7778 0ZM15.8889 3.75C16.5649 3.75 17.1111 4.30859 17.1111 5V18.75C17.1111 19.4414 16.5649 20 15.8889 20C15.2128 20 14.6667 19.4414 14.6667 18.75V5C14.6667 4.30859 15.2128 3.75 15.8889 3.75ZM12.2222 8.75V18.75C12.2222 19.4414 11.676 20 11 20C10.324 20 9.77778 19.4414 9.77778 18.75V8.75C9.77778 8.05859 10.324 7.5 11 7.5C11.676 7.5 12.2222 8.05859 12.2222 8.75ZM6.11111 11.25C6.78715 11.25 7.33333 11.8086 7.33333 12.5V18.75C7.33333 19.4414 6.78715 20 6.11111 20C5.43507 20 4.88889 19.4414 4.88889 18.75V12.5C4.88889 11.8086 5.43507 11.25 6.11111 11.25ZM2.44444 16.25V18.75C2.44444 19.4414 1.89826 20 1.22222 20C0.546181 20 0 19.4414 0 18.75V16.25C0 15.5586 0.546181 15 1.22222 15C1.89826 15 2.44444 15.5586 2.44444 16.25Z"
                              fill="#FF3535"
                            />
                            <path
                              d="M20.5 20L4.5 4"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                            <path
                              d="M21.5 19L5.5 3"
                              stroke="#FF3535"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </svg>

                          <div class="tooltip-content">
                            Offline
                            <div class="tooltip-arrow"></div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div>
                    <div>
                      <div class="tooltip-container">
                        {d?.custrecord_bg_asset_status === "In Transit" && (
                          <>
                            {" "}
                            {/* <FaTruckArrowRight class="tooltip-target" />{" "} */}
                            <svg
                              width="25"
                              height="20"
                              class="tooltip-target"
                              viewBox="0 0 25 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.875 0C0.839844 0 0 0.839844 0 1.875V14.375C0 15.4102 0.839844 16.25 1.875 16.25H2.5C2.5 18.3203 4.17969 20 6.25 20C8.32031 20 10 18.3203 10 16.25H15C15 18.3203 16.6797 20 18.75 20C20.8203 20 22.5 18.3203 22.5 16.25H23.75C24.4414 16.25 25 15.6914 25 15C25 14.3086 24.4414 13.75 23.75 13.75V11.25V10V9.26953C23.75 8.60547 23.4883 7.96875 23.0195 7.5L20 4.48047C19.5312 4.01172 18.8945 3.75 18.2305 3.75H16.25V1.875C16.25 0.839844 15.4102 0 14.375 0H1.875ZM16.25 6.25H18.2305L21.25 9.26953V10H16.25V6.25ZM4.375 16.25C4.375 15.7527 4.57254 15.2758 4.92417 14.9242C5.27581 14.5725 5.75272 14.375 6.25 14.375C6.74728 14.375 7.22419 14.5725 7.57583 14.9242C7.92746 15.2758 8.125 15.7527 8.125 16.25C8.125 16.7473 7.92746 17.2242 7.57583 17.5758C7.22419 17.9275 6.74728 18.125 6.25 18.125C5.75272 18.125 5.27581 17.9275 4.92417 17.5758C4.57254 17.2242 4.375 16.7473 4.375 16.25ZM18.75 14.375C19.2473 14.375 19.7242 14.5725 20.0758 14.9242C20.4275 15.2758 20.625 15.7527 20.625 16.25C20.625 16.7473 20.4275 17.2242 20.0758 17.5758C19.7242 17.9275 19.2473 18.125 18.75 18.125C18.2527 18.125 17.7758 17.9275 17.4242 17.5758C17.0725 17.2242 16.875 16.7473 16.875 16.25C16.875 15.7527 17.0725 15.2758 17.4242 14.9242C17.7758 14.5725 18.2527 14.375 18.75 14.375Z"
                                fill="#414C60"
                              />
                            </svg>
                            <div class="tooltip-content">
                              Device is currently in transit
                              <div class="tooltip-arrow"></div>
                            </div>
                          </>
                        )}
                        {d?.custrecord_bg_asset_status === "Active" && (
                          <>
                            {" "}
                            {/* <FaCircleCheck
                              class="tooltip-target"
                              color="green"
                            />{" "} */}
                            <svg xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              zoomAndPan="magnify"
                              viewBox="0 0 375 374.999991"
                              height="25"
                              preserveAspectRatio="xMidYMid meet" version="1.2">
                              <defs>
                                <clipPath id="69a77d3ca3">
                                  <path d="M 80 111 L 294 111 L 294 278.859375 L 80 278.859375 Z M 80 111 " />
                                </clipPath></defs><g id="8f0e77d345">
                                <path fill="#8AC640" d="M 187.5 53.773438 C 261.304688 53.773438 321.226562 
                                    113.695312 321.226562 187.5 C 321.226562 261.304688 261.304688 321.226562 187.5 321.226562 C 113.695312 321.226562 53.773438 261.304688 53.773438 187.5 C 53.773438 113.695312 113.695312 53.773438 187.5 53.773438 Z M 198.652344 0.457031 C 191.222656 0.015625 183.777344 0.015625 176.351562 0.457031 L 163.410156 30.0625 C 151.859375 31.832031 140.535156 34.867188 129.644531 39.109375 L 103.632812 19.941406 C 96.980469 23.269531 90.53125 26.996094 84.320312 31.089844 L 87.917969 63.203125 C 78.796875 70.507812 70.507812 78.796875 63.199219 87.917969 L 31.089844 84.320312 C 26.996094 90.53125 23.269531 96.980469 19.941406 103.632812 L 39.113281 129.644531 C 34.867188 140.53125 31.832031 151.855469 30.066406 163.40625 L 0.457031 176.347656 C 0.015625 183.777344 0.015625 191.222656 0.457031 198.648438 L 30.066406 211.589844 C 31.832031 223.140625 34.867188 234.464844 39.113281 245.355469 L 19.941406 271.363281 C 23.269531 278.015625 26.996094 284.464844 31.089844 290.675781 L 63.203125 287.082031 C 70.507812 296.203125 78.796875 304.492188 87.917969 311.796875 L 84.324219 343.90625 C 90.535156 348.003906 96.984375 351.726562 103.636719 355.058594 L 129.644531 335.886719 C 140.535156 340.132812 151.855469 343.167969 163.410156 344.933594 L 176.351562 374.542969 C 183.777344 374.984375 191.222656 374.984375 198.652344 374.542969 L 211.589844 344.933594 C 223.144531 343.167969 234.464844 340.132812 245.355469 335.886719 L 271.363281 355.058594 C 278.019531 351.730469 284.46875 348.003906 290.675781 343.90625 L 287.082031 311.796875 C 296.203125 304.488281 304.492188 296.203125 311.796875 287.082031 L 343.90625 290.675781 C 348.003906 284.464844 351.730469 278.015625 355.058594 271.363281 L 335.886719 245.355469 C 340.132812 234.464844 343.167969 223.140625 344.933594 211.589844 L 374.542969 198.648438 C 374.984375 191.222656 374.984375 183.777344 374.542969 176.347656 L 344.933594 163.410156 C 343.167969 151.859375 340.132812 140.535156 335.886719 129.644531 L 355.058594 103.636719 C 351.730469 96.984375 348.003906 90.535156 343.90625 84.324219 L 311.796875 87.921875 C 304.492188 78.796875 296.203125 70.511719 287.082031 63.203125 L 290.675781 31.09375 C 284.464844 26.996094 278.015625 
                                    23.273438 271.363281 19.941406 L 245.355469 39.113281 C 234.46875 34.867188 
                                    223.144531 31.832031 211.589844 30.066406 Z M 198.652344 0.457031 " />
                                <g clip-rule="nonzero" clip-path="url(#69a77d3ca3)">
                                  <path fill="#8AC640" d="M 286.421875 116.621094 C 277.667969 108.792969 264.207031 
                                      109.515625 256.375 118.292969 L 159.667969 226.375 L 117.25 183.375 C 109 
                                      175.007812 95.519531 174.917969 87.152344 183.179688 C 78.792969 191.4375 78.695312 204.914062 
                                      86.953125 213.285156 L 145.28125 272.394531 C 149.285156 276.449219 154.746094 278.71875 160.4375 
                                      278.71875 C 160.605469 278.71875 160.777344 278.71875 160.960938 278.71875 C 166.835938 278.582031 
                                      172.382812 276.011719 176.292969 271.625 L 288.09375 146.660156 C 295.929688 137.910156 295.171875 
                                      124.449219 286.421875 116.621094 Z M 286.421875 116.621094" /></g></g>
                            </svg>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#8AC640" class="icon icon-tabler icons-tabler-filled icon-tabler-circle"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" /></svg> */}


                            <div class="tooltip-content">
                              Device is active
                              <div class="tooltip-arrow"></div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr style={{ margin: "0rem" }} />
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default WoInfoOrderS;
